document.documentElement.classList.remove('no-js');

// Utilitaire partagé : bascule un attribut aria-expanded et une classe "is-open"
// Réutilisé par le menu mobile, les onglets produit et l'accordéon FAQ.
window.PlatoUtils = {
  toggleOpen(trigger, target) {
    const isOpen = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!isOpen));
    target.classList.toggle('is-open', !isOpen);
  }
};

// Révélation subtile au défilement — un seul déclenchement par élément.
// Chaque section pose data-animate="fade-up" (et un délai optionnel via
// style="--reveal-delay: 80ms") sur les blocs qu'elle veut révéler.
(function initScrollReveal() {
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var items = document.querySelectorAll('[data-animate]');
  if (!items.length) return;

  if (prefersReduced || !('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('is-in-view'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in-view');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  items.forEach(function (el) { observer.observe(el); });
})();

// Lignes du Hero synchronisées au défilement — le tracé se dessine
// progressivement pendant que la section Hero traverse le viewport.
(function initHeroLines() {
  var svg = document.querySelector('.hero__lines');
  if (!svg) return;
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var paths = Array.prototype.slice.call(svg.querySelectorAll('path'));
  if (!paths.length) return;

  var lengths = paths.map(function (path) {
    var length = path.getTotalLength();
    path.style.strokeDasharray = length;
    path.style.strokeDashoffset = prefersReduced ? 0 : length;
    return length;
  });

  if (prefersReduced) return;

  var hero = svg.closest('.hero');
  var ticking = false;

  function update() {
    ticking = false;
    var rect = hero.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var total = rect.height + viewportHeight;
    var traveled = viewportHeight - rect.top;
    var progress = traveled / total;
    progress = Math.min(Math.max(progress, 0), 1);

    paths.forEach(function (path, index) {
      var length = lengths[index];
      path.style.strokeDashoffset = length - length * progress;
    });
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  update();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
})();
